const googleApiKey = {
  API_KEY: `AIzaSyCm-Uf7xowuaRZ2Aqhd3SgDhc-fq-8LBAM`,
};

export default googleApiKey;
